/**
 * System States Types
 *
 * Defines operational modes for state-based FMEA.
 * States represent different operational contexts (IDLE, DEPLOYMENT, GRINDING, etc.)
 * where the same failure can have different RPN values.
 */
/**
 * State type classification enum (sow-286)
 * Proper FMEA methodology classification instead of name-based heuristics
 */
export var StateType;
(function (StateType) {
    StateType["OPERATIONAL"] = "OPERATIONAL";
    StateType["INITIAL"] = "INITIAL";
    StateType["FAULT"] = "FAULT";
    StateType["EMERGENCY"] = "EMERGENCY";
    StateType["TRANSITION"] = "TRANSITION";
    StateType["MAINTENANCE"] = "MAINTENANCE";
})(StateType || (StateType = {}));
/**
 * State type metadata for UI display
 */
export const STATE_TYPE_META = {
    [StateType.OPERATIONAL]: { label: 'Operational', color: '#2563eb', bgColor: '#eff6ff', icon: '✓' },
    [StateType.INITIAL]: { label: 'Initial', color: '#059669', bgColor: '#ecfdf5', icon: '○' },
    [StateType.FAULT]: { label: 'Fault', color: '#dc2626', bgColor: '#fef2f2', icon: '⚠' },
    [StateType.EMERGENCY]: { label: 'Emergency', color: '#7c2d12', bgColor: '#fff7ed', icon: '🛑' },
    [StateType.TRANSITION]: { label: 'Transition', color: '#7c3aed', bgColor: '#f5f3ff', icon: '↔' },
    [StateType.MAINTENANCE]: { label: 'Maintenance', color: '#ca8a04', bgColor: '#fefce8', icon: '🔧' },
};
/**
 * Type guard for StateType
 */
export function isStateType(value) {
    return Object.values(StateType).includes(value);
}
/**
 * Power level enum
 */
export var PowerLevel;
(function (PowerLevel) {
    PowerLevel["OFF"] = "OFF";
    PowerLevel["LOW"] = "LOW";
    PowerLevel["MEDIUM"] = "MEDIUM";
    PowerLevel["HIGH"] = "HIGH";
})(PowerLevel || (PowerLevel = {}));
/**
 * Motion level enum
 */
export var MotionLevel;
(function (MotionLevel) {
    MotionLevel["STATIONARY"] = "STATIONARY";
    MotionLevel["SLOW"] = "SLOW";
    MotionLevel["FAST"] = "FAST";
})(MotionLevel || (MotionLevel = {}));
/**
 * Type guard for PowerLevel
 */
export function isPowerLevel(value) {
    return Object.values(PowerLevel).includes(value);
}
/**
 * Type guard for MotionLevel
 */
export function isMotionLevel(value) {
    return Object.values(MotionLevel).includes(value);
}
//# sourceMappingURL=system-states.types.js.map